"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new Error('The installed version of React does not support Context. ' +
    'Upgrade to React v16.3.0 or later.');
